<app-fr-card *ngIf="campaigner" class="fr-campaigner-card">
  <small *ngIf="contactBtn" class="contact" (click)="openContact(campaigner.full_name)">
    <span class="ml-1 contact-icon-container"> <mat-icon class="contact-icon">mail_outline</mat-icon>Contact</span>
  </small>
  <mat-card-header class="header">
    <div class="img" *ngIf="!campaigner.avtar" mat-card-avatar>
      <strong>{{setName(campaigner.full_name) | uppercase}}</strong>
    </div>
    <img loading="lazy" mat-card-avatar *ngIf="campaigner?.avtar" class="img donor-img" [attr.data-src]="campaigner?.avtar?.cdn_path" alt="{{campaigner?.full_name}}" />
    <mat-card-subtitle class="subtitle">
      <span class="person">{{beneficiary && beneficiary.full_name?'Campaigner':'Campaigner & Beneficiary'}}</span>
    </mat-card-subtitle>
    <mat-card-title class="title campaigner-color" #verifiedImg>
      <span class="title-text text-capitalize">{{campaigner.full_name}}</span>
      <img loading="lazy" *ngIf="fundraiser.parent_cause_id !== 20" class="icon-verified" [attr.data-src]="'/assets/images/verifiednew.png'" (mouseover)="showPopover = true" (mouseout)="showPopover = false" alt="Verified" />
    </mat-card-title>
    <mat-card-subtitle *ngIf="campaigner.social?.friends_count" class="fb-count">
      <mat-icon class="icon-fb"></mat-icon> {{friendscount}}+ friends
    </mat-card-subtitle>
    <mat-card-subtitle class="subtitle">
      <mat-icon *ngIf="campaigner?.city">location_on</mat-icon> {{campaigner.city}}
    </mat-card-subtitle>
  </mat-card-header>

  <div *ngIf="beneficiary && beneficiary.full_name && !fundraiser?.settings?.nobenedetails">
    <div class="line"></div>
    <small *ngIf="beneficiary?.entity_type==='ngo' && contactBtn" class="contact" (click)="openContact(beneficiary.full_name)">
      <span class="ml-1 contact-icon-container"><mat-icon class="contact-icon">mail_outline</mat-icon>Contact</span>
    </small>
    <mat-card-header class="header">
      <div mat-card-avatar *ngIf="!beneficiary.avtar" class="img"><strong>{{setName(beneficiary.full_name) | uppercase}}</strong></div>
      <img loading="lazy" mat-card-avatar *ngIf="beneficiary.avtar" class="img donor-img" [attr.data-src]="beneficiary.avtar.cdn_path" alt="{{beneficiary?.full_name}}" />
      <mat-card-subtitle class="subtitle">
        <span class="person">{{beneficiary?.entity_type=='ngo'?'Benefiting NGO':'Beneficiary'}}</span>
      </mat-card-subtitle>
      <mat-card-title class="title campaigner-color text-capitalize">{{beneficiary.full_name}}</mat-card-title>
      <mat-card-subtitle class="subtitle mb-1">{{tax}}</mat-card-subtitle>
      <mat-card-subtitle class="subtitle mb-1" *ngIf="campaigner.entity_type=='individual'">{{beneficiary?.relation}}</mat-card-subtitle>
      <mat-card-subtitle class="subtitle" *ngIf="beneficiary.disable_foreign_donation">Only INR contributions accepted</mat-card-subtitle>
    </mat-card-header>
  </div>
</app-fr-card>

<!-- Verified popup S-->
<app-popover-loader *ngIf="showPopover" [show]="showPopover" [config]="{social: campaigner?.social, class: 'v6'}" (hideel)="showPopover = $event"></app-popover-loader>

<!-- Campainer Info -->
<ng-template #aboutCampainer>
  <div class="dialog">
    <div class="c-close">
      <button class="close-btn" (click)="dialog.closeAll()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <div class="dialog-content" matDialogContent>
      <div class="dialog-title">About Campainer</div>
      <div class="campainer">
        <img loading="lazy" class="c-img" [attr.data-src]="campaigner?.avtar?.cdn_path" alt="{{campaigner?.full_name}}" />
        <div class="c-details">
          <span class="c-name text-capitalize">{{campaigner.full_name}}</span>
          <span class="c-location">
            <mat-icon class="l-icon" *ngIf="campaigner?.city">location_on</mat-icon>{{campaigner.city}}
          </span>
        </div>
      </div>
      <span class="line"></span>
      <div class="c-verified">
        <span class="c-title">Verification</span>
        <ul class="c-verfied-list">
          <li *ngIf="campaigner?.social" class="c-list-item">
            <mat-icon class="c-item-icon">check_circle_outline</mat-icon> Facebook Verified ({{friendscount}}+ friends)
          </li>
          <li class="c-list-item">
            <mat-icon class="c-item-icon">check_circle_outline</mat-icon> Email Verified
          </li>
          <li class="c-list-item">
            <mat-icon class="c-item-icon">check_circle_outline</mat-icon> Identity Verified
          </li>
        </ul>
      </div>
      <div >
        <span class="line"></span>
        <div class="c-verified">
          <span class="c-title"> Impact</span>
          <ul class="c-verfied-list">
            <li *ngIf="fundraiser?.campaigner?.agg_fundraiser?.cnt" class="c-list-item">
              <mat-icon class="icon-file-text2 icon"></mat-icon> {{fundraiser?.campaigner?.agg_fundraiser?.cnt}} Fundraiser Created
            </li>
            <li *ngIf="fundraiser?.campaigner?.aggdonation?.funds" class="c-list-item">
              <mat-icon class="icon-dollar icon"></mat-icon> {{fundraiser?.campaigner?.aggdonation?.funds}} Contribution
            </li>
          </ul>
        </div>
      </div>
      <div *ngIf="fundraiser?.activeteam && fundraiser?.activeteam.length">
        <span class="line"></span>
        <div class="c-verified">
          <span class="c-title">Team</span>
          <ul class="c-verfied-list">
            <li class="c-list-item" *ngFor="let item of fundraiser?.activeteam">
              <app-donor [donor]="item.member"></app-donor>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="dialog-footer" matDialogActions>
      <button class="action report" (click)="reportProject()" mat-stroked-button>Report this project</button>
      <button class="action contact" (click)="openContact(campaigner.full_name)" mat-raised-button>Contact Campaigner</button>
    </div>
  </div>
</ng-template>